import script from "./Menu.vue?vue&type=script&setup=true&lang=js"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=0f558173&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f558173"]])

export default __exports__